import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  FormControlLabel,
  FormControl, RadioGroup, Radio,
  InputLabel, FormHelperText
} from '@material-ui/core'

const FormRadioGroupField = ({ formActions, classes, name, labelKey, label, list, required, extraAttrs, row, disabled, small, large, column, returnValue }) => {
  const intl = useIntl()

  const handleRadioChange = (event) => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    formActions.setFieldValue(name, event.target.value.toString())
    if (!!returnValue) {
      returnValue(event.target.value.toString())
    }
  }
  let newClasses = [
    !!row ? classes.FormRow : '',
    !!small ? classes.FormSmall : '',
    !!large ? classes.FormLarge : '',
    !!column ? classes.column : ''
  ].filter(item => !!item).join(' ')
  return (
    <div className={classes.FormItem + ` ${newClasses}`}>
      <InputLabel htmlFor={name}>{label ?? <FormattedMessage id={labelKey}/>}{!!required &&
      <span className={'required'}>*</span>}: </InputLabel>
      <FormControl variant="outlined">
        <RadioGroup aria-label={label ?? intl.formatMessage({ id: labelKey })}
                    required={required}
                    disabled={!!disabled}
                    name={name}
                    id={name}
                    margin={'dense'}
                    variant="outlined"
                    value={!!list?.length ? formActions.values[name] : ''}
                    onChange={handleRadioChange}
                    onBlur={formActions.handleBlur}
          // error={!!formActions.errors[name] && formActions.touched[name] !== undefined}
                    {...extraAttrs}
        >
          {list?.map((item) => (
            <FormControlLabel key={item.key} value={item.key} control={<Radio color={'primary'}/>}
                              disabled={item.disabled || false}
                              label={<>
                                {item.name}
                                {!!item.description &&
                                <FormHelperText>{item.description}</FormHelperText>}
                              </>}/>
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  )
}

export default FormRadioGroupField
